import { FormattedMessage } from 'react-intl';
import { clsx } from 'clsx';
import { useState } from 'react';
import BlockTitle from '../../../layout/BlockTitle';
import { copyToBuffer } from '../../../../../utils/copyPaste';
import copyIcon from '../../../../../../assets/icons/copy-icon.svg';
import checkIcon from '../../../../../../assets/icons/check-green.svg';
import styles from './RouterCredentialsBlock.scss';

interface RouterCredentialsBlockProps {
  username: string;
  password: string;
}

const animationDurationMills = 2500;

const CopyButton = ({ value }: { value: string }) => {
  const [isCheckShown, setIsCheckShown] = useState(false);

  return (
    <button
      type="button"
      className={clsx(styles.copyButton, isCheckShown && styles.copied)}
      onClick={() => {
        copyToBuffer(value);
        setIsCheckShown(true);
        setTimeout(() => {
          setIsCheckShown(false);
        }, animationDurationMills);
      }}
    >
      <div className={styles.copyButtonGallery}>
        <img src={copyIcon} alt="" />
        <img src={checkIcon} alt="" />
      </div>
    </button>
  );
};

const RouterCredentialsBlock = ({ username, password }: RouterCredentialsBlockProps) => (
  <article>
    <BlockTitle className={styles.title}>
      <FormattedMessage id="profile.routerSection.credentialsBlock.title" defaultMessage="Credentials" />
    </BlockTitle>
    <p className={styles.text}>
      <FormattedMessage
        id="profile.routerSection.credentialsBlock.text"
        defaultMessage="These are your unique username and password for the router configuration. Using separate credentials provides extra level of security."
      />
    </p>

    <BlockTitle className={styles.fieldTitle}>
      <FormattedMessage id="profile.routerSection.credentialsBlock.username" defaultMessage="Username" />
    </BlockTitle>
    <span className={clsx(styles.copyField, styles.copyFieldUsername)}>
      {username} <CopyButton value={username} />
    </span>

    <BlockTitle className={styles.fieldTitle}>
      <FormattedMessage id="profile.routerSection.credentialsBlock.password" defaultMessage="Password" />
    </BlockTitle>
    <span className={styles.copyField}>
      {password} <CopyButton value={password} />
    </span>
  </article>
);

export default RouterCredentialsBlock;
